const prefixName = '@system/';

export const HAS_ERROR = `${prefixName}has_error`;
export const IS_LOADING = `${prefixName}is_loading`;
export const INITIAL_CHARGE = `${prefixName}initial_charge`;
export const GET_COMPANY = `${prefixName}get_company`;
export const UPDATE_WEBSOCKET = `${prefixName}update_websocket`;
